import React, { useEffect, useState } from 'react';
import {
  Dialog, DialogContent, Box, Typography, Button, IconButton, TextField
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { useNavigate } from 'react-router-dom';

const SESSION_KEY = 'akdme_exit_popup_shown';

function ExitIntentPopup() {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [claimed, setClaimed] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem(SESSION_KEY)) return;

    const handleMouseLeave = (e) => {
      if (e.clientY <= 5) {
        setOpen(true);
        sessionStorage.setItem(SESSION_KEY, '1');
        document.removeEventListener('mouseleave', handleMouseLeave);
      }
    };

    const timer = setTimeout(() => {
      document.addEventListener('mouseleave', handleMouseLeave);
    }, 8000);

    return () => {
      clearTimeout(timer);
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  const handleClaim = () => {
    if (email) {
      setClaimed(true);
    }
  };

  const handleClose = () => setOpen(false);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          background: 'linear-gradient(135deg, rgba(30,36,38,0.98) 0%, rgba(45,52,54,0.98) 100%)',
          border: '1px solid rgba(255,107,107,0.3)',
          borderRadius: '20px',
          backdropFilter: 'blur(20px)',
          overflow: 'hidden',
        },
      }}
    >
      {/* Top accent bar */}
      <Box sx={{
        height: 4,
        background: 'linear-gradient(90deg, #ff6b6b 0%, #ffd93d 100%)',
      }} />

      <DialogContent sx={{ p: { xs: 3, md: 5 }, position: 'relative' }}>
        <IconButton
          onClick={handleClose}
          sx={{
            position: 'absolute', top: 12, right: 12,
            color: 'rgba(255,255,255,0.5)',
            '&:hover': { color: '#fff', background: 'rgba(255,107,107,0.1)' },
          }}
        >
          <CloseIcon />
        </IconButton>

        {!claimed ? (
          <Box sx={{ textAlign: 'center' }}>
            <Box sx={{
              width: 72, height: 72, borderRadius: '18px',
              background: 'rgba(255,107,107,0.12)',
              border: '1px solid rgba(255,107,107,0.25)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              mx: 'auto', mb: 3,
            }}>
              <LocalOfferIcon sx={{ fontSize: 36, color: 'primary.main' }} />
            </Box>

            <Typography variant="overline" sx={{ color: 'primary.main', fontWeight: 600, letterSpacing: 3 }}>
              Wait — Before You Go!
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: 800, color: '#fff', mt: 1, mb: 1.5 }}>
              Get{' '}
              <Box component="span" className="gradient-text">10% Off</Box>
              {' '}Your First Repair
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 4, lineHeight: 1.7 }}>
              Enter your email and we'll send you a discount code — valid for any repair or IT service.
            </Typography>

            <Box sx={{ display: 'flex', gap: 1.5, flexDirection: { xs: 'column', sm: 'row' } }}>
              <TextField
                fullWidth
                placeholder="your@email.com"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                size="small"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    color: '#fff',
                    background: 'rgba(255,255,255,0.05)',
                    '& fieldset': { borderColor: 'rgba(255,107,107,0.3)' },
                    '&:hover fieldset': { borderColor: 'rgba(255,107,107,0.6)' },
                  },
                }}
              />
              <Button
                variant="contained"
                onClick={handleClaim}
                sx={{
                  background: 'linear-gradient(135deg, #ff6b6b 0%, #ffd93d 100%)',
                  color: '#2d3436', fontWeight: 700,
                  whiteSpace: 'nowrap', px: 3,
                  '&:hover': { background: 'linear-gradient(135deg, #ff5252 0%, #ffd93d 100%)' },
                }}
              >
                Claim Discount
              </Button>
            </Box>

            <Button
              onClick={handleClose}
              sx={{ mt: 2, color: 'rgba(255,255,255,0.35)', fontSize: '0.8rem' }}
            >
              No thanks, I'll pay full price
            </Button>
          </Box>
        ) : (
          <Box sx={{ textAlign: 'center', py: 2 }}>
            <Typography variant="h5" className="gradient-text" sx={{ fontWeight: 700, mb: 2 }}>
              🎉 Discount Claimed!
            </Typography>
            <Typography color="text.secondary" sx={{ mb: 1 }}>
              Use code <strong style={{ color: '#ff6b6b' }}>AKDME10</strong> when booking.
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
              We'll also send the code to <strong>{email}</strong>
            </Typography>
            <Button
              variant="contained"
              onClick={() => { handleClose(); navigate('/book-service'); }}
              sx={{
                background: 'linear-gradient(135deg, #ff6b6b 0%, #ffd93d 100%)',
                color: '#2d3436', fontWeight: 700, px: 4,
              }}
            >
              Book Now
            </Button>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default ExitIntentPopup;
